let failures = 0;
let started: number | undefined;
export function recordAuthRecovery(reason: string) {
  if (reason === 'AUTH_UNAVAILABLE') {
    if (started === undefined) started = performance.now();
    failures += 1;
  } else { failures = 0; started = undefined; }
}
export function recoveryDelay() { return Math.min(60_000, 10_000 * 2 ** Math.min(3, Math.max(0, failures - 1))); }
export function recoveryMessage() {
  return '网络暂时不稳，正在自动重新连接……' + (started !== undefined && performance.now() - started >= 180_000 ? '请检查电脑网络。' : '');
}
